import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Row } from '../../atoms';
import { CurrencyIcon } from '../currency-icon';
const tokensWithIcons = {
    BTC: 'BTC',
    ETH: 'ETH',
    SOL: 'SOL',
    DH_BTC: 'DHBTC',
    XCOF_O: 'XCOF',
    XCOF_T: 'TREND',
};
const tokens = Object.keys(tokensWithIcons);
const tokensRegex = new RegExp(`:(${tokens.join('|')}):`, 'g');
export const TextWithIcons = memo(({ message, color, TextComp, }) => {
    const parts = message.split(tokensRegex);
    return (_jsx(Row.L, { style: $.messageWrapper, children: parts.map((part, i) => {
            const code = tokensWithIcons[part];
            if (tokens.includes(part)) {
                return code ? (_jsx(CurrencyIcon, { code: code, size: "sm" }, i)) : (_jsx(TextComp, { color: color, children: part.trim() }));
            }
            else {
                return (_jsx(TextComp, { color: color, children: part.trim() }, i));
            }
        }) }));
});
const $ = StyleSheet.create({
    messageWrapper: {
        // best estimate for the width of 1 space character
        gap: theme.spacing['1'],
        maxWidth: '100%',
    },
});
